/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Open Source Version is distributed with Sencha Ext JS pursuant to a FLOSS Exception agreed upon
 * between Sonatype, Inc. and Sencha Inc. Sencha Ext JS is licensed under GPL v3 and cannot be redistributed as part of a
 * closed source work.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

// Ensure hash-based routing in dev/debug. If someone navigates without a hash (e.g. /admin/system/tasks),
// rewrite to the equivalent hash URL so ui-router doesn't emit "url not recognized".
if (typeof window !== 'undefined' && !window.__nxHashEnforced) {
  window.__nxHashEnforced = true;
  const { hash, pathname, search, origin } = window.location;
  if (!hash && pathname && pathname !== '/') {
    const cleaned = pathname.replace(/^\/+/, '');
    const newUrl = `${origin}${search || ''}#/${cleaned}`;
    window.location.replace(newUrl);
  }
}

// Suppress noisy ExtJS debug chatter early during boot so it doesn't flood debug logs.
if (typeof window !== 'undefined' && !window.__nxExtJsDebugPatchedGlobal) {
  window.__nxExtJsDebugPatchedGlobal = true;
  
  // Patterns to suppress - ExtJS internal chatter that clutters the console
  const suppressPatterns = [
    'NX.app.Loader',
    'NX.app.Application',
    'evaluating transition',
    'Redirecting to login',
    'managed controllers',
    'Configured error handling',
    'Configured Ext.Direct',
    'Configured state provider',
    'responsive plugin is deprecated',
    '[verify]',
  ];

  const shouldSuppress = (args) =>
    args.some((arg) => typeof arg === 'string' && 
      suppressPatterns.some(pattern => arg.includes(pattern)));

  const wrap = (originalFn) => (...args) => {
    if (shouldSuppress(args)) {
      return;
    }
    originalFn && originalFn(...args);
  };

  console.debug = wrap(console.debug?.bind(console));
  console.info = wrap(console.info?.bind(console));
  console.log = wrap(console.log?.bind(console));
  console.warn = wrap(console.warn?.bind(console));
}

import './App';
import S3BlobStoreSettings from './components/pages/admin/BlobStores/S3/S3BlobStoreSettings';
import S3BlobStoreWarning from './components/pages/admin/BlobStores/S3/S3BlobStoreWarning';
import S3BlobStoreActions from './components/pages/admin/BlobStores/S3/S3BlobStoreActions';
import AzureBlobStoreSettings from './components/pages/admin/BlobStores/Azure/AzureBlobStoreSettings';
import AzureBlobStoreActions from './components/pages/admin/BlobStores/Azure/AzureBlobStoreActions';
import GoogleBlobStoreSettings from './components/pages/admin/BlobStores/Google/GoogleBlobStoreSettings';
import GoogleBlobStoreActions from './components/pages/admin/BlobStores/Google/GoogleBlobStoreActions';
import FileBlobStoreWarning from './components/pages/admin/BlobStores/File/FileBlobStoreWarning';
import CommunityEulaOnboarding from './components/pages/onboarding/CommunityEulaOnboarding';
import CommunityDiscoverOnboarding from './components/pages/onboarding/CommunityDiscoverOnboarding';
import './styles/extjs.scss';

window.BlobStoreTypes = {
  ...window.BlobStoreTypes,
  azure: {
    Settings: AzureBlobStoreSettings,
    Actions: AzureBlobStoreActions
  },
  s3: {
    Settings: S3BlobStoreSettings,
    Warning: S3BlobStoreWarning,
    Actions: S3BlobStoreActions
  },
  google: {
    Settings: GoogleBlobStoreSettings,
    Actions: GoogleBlobStoreActions
  },
  file: {
    Warning: FileBlobStoreWarning
  }
}

window.ReactComponents = {
  ...window.ReactComponents,
  CommunityEulaOnboarding,
  CommunityDiscoverOnboarding,
};
